import { Table } from '@tanstack/react-table';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { IServerSideTableOptions } from '../../types';

import { PageArrow, Direction } from './page-arrow';
import { PagePickerContents } from './page-picker-contents';
import { usePaginationHandlers } from './pagination-hooks';

interface ITablePaginationProps<TData> {
  readonly currentPageSize: number;
  readonly manipulationOptions?: IServerSideTableOptions;
  readonly pageCount: number;
  readonly table: Table<TData>;
}
function TablePagination<TData>({
  currentPageSize,
  manipulationOptions,
  pageCount,
  table,
}: ITablePaginationProps<TData>) {
  const { pageIndex } = table.getState().pagination;
  const { currentPage, canPreviousPage, canNextPage, handlePreviousPage, handleNextPage, handlePageChange } =
    usePaginationHandlers({
      table,
      currentPageSize,
      pageCount,
      manipulationOptions,
    });
  const { t } = useTranslation();

  return (
    <nav
      aria-label={t('ui-components.table.pagination.label')}
      className="flex items-center justify-between space-x-2 pt-5 pb-5 pl-5 pr-5"
    >
      <PageArrow direction={Direction.PREVIOUS} disabled={!canPreviousPage} onClick={handlePreviousPage} />
      <div className="flex flex-row items-center space-x-2">
        <PagePickerContents
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          pageCount={pageCount}
          pageIndex={pageIndex}
        />
      </div>
      <PageArrow direction={Direction.NEXT} disabled={!canNextPage} onClick={handleNextPage} />
    </nav>
  );
}
export type { ITablePaginationProps };
export { TablePagination };
